export const concatUsername = (firstname = '', lastname = '', fallbackText = '') => {
  const hasValidname = firstname || lastname;
  return hasValidname ? `${firstname || ''} ${lastname || ''}`.trim() : fallbackText;
};
